import React, { createContext, useReducer, useContext, useEffect } from "react";

const initialStats = {
  flip_won: 0,
  flip_lost: 0,
  flip_abandoned: 0,
  flip_matched: 0,
  flip_wrong: 0
};

const initialState = {
  stats: initialStats,
  paused: false,
  cards: [],
  foundCards: [],
  flipped: [],
};

const GameContext = createContext();

function reducer(state, action) {
  switch (action.type) {
    case "SET_CARDS":
      return { ...state, cards: action.payload };
    case "FLIP_CARD":
      return { ...state, flipped: [...state.flipped, action.payload] };
    case "CLEAR_FLIPPED":
      return { ...state, flipped: [] };
    case "ADD_FOUND":
      return { ...state, foundCards: [...state.foundCards, ...action.payload] };
    case "SET_GAME_START":
      return { ...state, gameStart: action.payload };
    case "TOGGLE_PAUSE":
      return { ...state, paused: !state.paused };
    case "SET_STATS":
      return { ...state, stats: action.payload };
    case "UPDATE_STAT":
      return {
        ...state,
        stats: { ...state.stats, [action.key]: action.value },
      };
    case "SAVE_STATS": {

      const {flips, correct, wrong, level, result } = action.payload;
      const newMatched =  correct;
      const newWrong =  wrong;
      localStorage.setItem("flip_matched", newMatched);
      localStorage.setItem("flip_wrong", newWrong);
      return {
        ...state,
        stats: {
          ...state.stats,
          flip_matched: newMatched,
          flip_wrong: newWrong,
          flip_won: state.stats.flip_won + 1
        }
      };
    }

    default:
      return state;
  }
}

export const GameProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  // Load stats from localStorage on mount
  useEffect(() => {
    const localStats = {};
    Object.keys(initialStats).forEach((key) => {
      const stored = localStorage.getItem(key);
      if (stored === null || stored === undefined) {
        localStats[key] = initialStats[key];
      } else if (!isNaN(stored)) {
        localStats[key] = parseInt(stored, 10);
      } else {
        localStats[key] = stored;
      }
    });
    dispatch({ type: "SET_STATS", payload: localStats });
  }, []);


  // Save a single stat
  const updateStat = (key, value) => {
    localStorage.setItem(key, value);
    dispatch({ type: "UPDATE_STAT", key, value });
  };

  // Increment a numeric stat
  const increase = (key) => {
    const current = parseInt(localStorage.getItem(key)) || state.stats[key] || 0;
    updateStat(key, current + 1);
  };

  // Decrement a numeric stat
  const decrease = (key) => {
    const current = parseInt(localStorage.getItem(key)) || state.stats[key] || 0;
    updateStat(key, current - 1);
  };

  // Save best time for given difficulty
  const setBestTime = (level, time) => {
    const key = `flip_${level}`;
    const current = localStorage.getItem(key);
    if (current === null || current === '-:-' || parseInt(current) > time) {
      updateStat(key, time);
    }
  };

  return (
    <GameContext.Provider
      value={{
        state,
        dispatch,
        increase,
        decrease,
        updateStat,
        setBestTime,
      }}
    >
      {children}
    </GameContext.Provider>
  );
};

export const useGame = () => useContext(GameContext);
